function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import BuildingBlocksTabComponent from "../building-blocks-tab/building-blocks-tab-component";
import BuildingBlocksTabContentComponent from "../building-blocks-tab-content/building-blocks-tab-content-component";
import { StyledBuildingBlocksTabsDesktopComponent } from "./building-blocks-tabs-desktop-component.scss";
const BuildingBlocksTabsDesktopComponent = (props)=>{
    const [selectedTab, setSelectedTab] = useState(0);
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const { tabs, buildingBlocksTabsTheme } = props;
    const VISIBILITY_SENSOR_OFFSET = -100;
    const tabsWithVideoPlayerRefs = [];
    tabs.forEach((tab)=>{
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            videoPlayerRef: useRef(null)
        }));
    });
    const onVisibilityChange = (isVisible)=>{
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    return /*#__PURE__*/ _jsx(VisibilitySensor, {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ _jsxs(StyledBuildingBlocksTabsDesktopComponent, {
            className: "building-blocks-tabs-desktop-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "building-blocks-tabs-wrapper",
                    role: "tablist",
                    children: tabsWithVideoPlayerRefs.map((value, index)=>{
                        return /*#__PURE__*/ _jsx(BuildingBlocksTabComponent, {
                            buildingBlock: value,
                            index: index,
                            selectedTab: selectedTab,
                            setSelectedTab: setSelectedTab,
                            themeColor: buildingBlocksTabsTheme
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "building-blocks-contents-wrapper",
                    children: tabsWithVideoPlayerRefs.map((tab, index)=>{
                        const isSelected = index === selectedTab;
                        // bring the first asset on load, and bring everything else when component is visible
                        const isAssetVisible = wasComponentEverVisible || isSelected;
                        return /*#__PURE__*/ _jsx(BuildingBlocksTabContentComponent, {
                            tab: tab,
                            isSelected: isSelected,
                            isAssetVisible: isAssetVisible,
                            buildingBlocksTabsTheme: buildingBlocksTabsTheme,
                            themeColor: buildingBlocksTabsTheme
                        }, index);
                    })
                })
            ]
        })
    });
};
export default BuildingBlocksTabsDesktopComponent;
